import { Box, Button, styled, TextField, Typography } from "@mui/material";

const modalStyle = {
    position: 'absolute',
    top: '18%',
    left: '27.5%',
    width: '45%',
    bgcolor: 'background.paper',
    textAlign: 'center',
    borderRadius: '15px',
};

const ModalLabel = styled(Box)(() => ({
    backgroundColor: '#41DBCE',
    fontSize: '1.3rem',
    color: '#FFFFFF',
    height: '2.2rem',
    paddingTop: '0.5rem',
    borderRadius: '15px 15px 0 0',
    textAlign: 'left',
    paddingLeft: '1rem',
    boxSizing: 'content-box'
}));

const InputFieldBox = styled(Box)(() => ({
    border: '2px solid #41DBCE',
    position: 'relative',
}));

const CancelButton = styled(Button)(() => ({
    backgroundColor: '#BFBFBF',
    color: '#000000',
    textAlign: 'center',
    fontSize: '1rem',
    fontWeight: 'bold',
    height: '2.5rem',
    width: '8rem',
    borderRadius: '100rem'
}));

const OkButton = styled(Button)(() => ({
    backgroundColor: '#01CFBE',
    color: '#FFFFFF',
    textAlign: 'center',
    fontSize: '1rem',
    fontWeight: 'bold',
    height: '2.5rem',
    width: '5rem',
    borderRadius: '100rem',
    marginLeft: '1rem'
}));

const SpecificationTypography = styled(Typography)(() => ({
    color: '#249e94ff',
    fontWeight: 'Bold',
    position: 'absolute',
    top: '15px',
    left: '20px',
}));

const ItemLabelBox = styled(Box)(() => ({
    backgroundColor: '#555555',
    width: '100%',
    height: '100%',
}));

const ItemLabelTypography = styled(Typography)(() => ({
    fontSize: '18px',
    color: '#FFFFFF',
    height: '100%',
    alignContent: 'center',
    textAlign: 'left',
}));

const ItemTextField = styled(TextField)(() => ({
    width: '100%',
    '& .MuiOutlinedInput-notchedOutline': { borderRadius: '0px' },
}));

export { modalStyle, ModalLabel, InputFieldBox, CancelButton, OkButton, SpecificationTypography, ItemLabelBox, ItemLabelTypography, ItemTextField }
